import React, { useState, useEffect } from 'react';

import { Box, TextField, Autocomplete } from '@mui/material';
import { useDocTypes } from '@/providers/DocTypesContext';
import type { DocumentType, DocumentTypeFieldProps } from '@/types';

interface ChartDocumentTypeFieldProps extends DocumentTypeFieldProps<DocumentType> {}

function ChartDocumentTypeField({
  value,
  setValue,
  setChanged,
  edit,
}: ChartDocumentTypeFieldProps): React.JSX.Element {
  const doc_types = useDocTypes();

  const [selected, setSelected] = useState<DocumentType | null>(value);
  const [options, setOptions] = useState<DocumentType[] | null>(null);

  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: DocumentType | null,
  ): void => {
    setChanged();
    setSelected(newValue);
    setValue(newValue);
  };

  useEffect(() => {
    if (doc_types && !options) {
      const filteredArray = doc_types.filter(
        (doc_type) => doc_type.enable_charts,
      );
      setOptions(filteredArray);
      setSelected(value);
    }
  }, [doc_types, options, value]);

  return (
    <Box>
      <Autocomplete
        id='document-types-field'
        options={options || []}
        value={selected || undefined}
        disabled={edit}
        sx={{ width: '100%' }}
        onChange={handleChange}
        getOptionLabel={(option) => `${option.name}`}
        disableClearable={true}
        renderInput={(params) => (
          <TextField {...params} required label='Chart Document Type' />
        )}
      />
    </Box>
  );
}

export default ChartDocumentTypeField;

